export default __webpack_public_path__ + "static/media/592.59643128.png";